import * as React from "react";
import {reduxForm, InjectedFormProps, formValueSelector} from 'redux-form'
import {AppState} from "../../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {frontEndConfig} from '../../../../../config/config';

import MessagePost from "../../../../common/organism/message_room/message_post";
import StickyBottomWrapper from "../../../../common/atom/wrapper/sticky_bottom_wrapper";
import {RefObject} from "react";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

interface IStateProps {
    initialValues: {
        fileURLFileObject?: File;
    } | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
    textareaRef: RefObject<HTMLTextAreaElement>
}

interface IState {
    image: string | null;
    imageError: string | null;
}

const validate = (values: any) => {
    const errors: any = {};
    return errors
};

export class CustomerMessageRoomForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {
            image: null,
            imageError: null,
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleKeyboardEvent = this.handleKeyboardEvent.bind(this);

    };

    public render(): JSX.Element {

        const {
            invalid, handleSubmit, pristine, submitting, error,
            textareaRef
        } = this.props;

        return (
            <StickyBottomWrapper>
                <form
                    name="customerMessageRoomForm"
                    onSubmit={handleSubmit}
                    onKeyDown={this._handleKeyboardEvent}
                >
                    <MessagePost
                        onchange={this.handleOnChange}
                        textareaRef={textareaRef}
                        disabled={pristine || submitting || invalid}
                        imageError={this.state.imageError}
                        formValues={this.props.formValues}
                        error={error}
                    />

                </form>
            </StickyBottomWrapper>
        )
    }

    private _handleKeyboardEvent = (ev: any) => {
        this.handleKeyboardEvent(ev, this.props.handleSubmit);
    };

    private handleKeyboardEvent(e: React.KeyboardEvent<HTMLElement>, cb: any) {

        if ((e.metaKey) && (e.key === 'Enter')) {
            cb();
        }

    }

    private handleOnChange(e: any) {
        const target: HTMLInputElement = e.target as HTMLInputElement;
        const file: File | null = (target.files) ? target.files.item(0) : null;
        // 同じファイルの連続した呼び出しに対応する為に、inputのValueをリセット
        target.value = '';

        try {
            this.setState({imageError: null});
            if (file) {
                if (file.size > uploadFileMaxSize) {
                    throw new Error("ファイルサイズオーバ");
                } else {
                    this.props.change("fileURLFileObject", file);
                }
            }
        } catch (error) {
            this.setState({imageError: error.message});
        }
    }

}

const selector = formValueSelector('customerMessageRoomForm');

const mapStateToProps = (state: AppState) => {
    return {
        formValues: selector(state, 'fileURLFileObject'),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};


export default reduxForm({
        form: 'customerMessageRoomForm',
        validate,
    }
)(connect(mapStateToProps, mapDispatchToProps)(CustomerMessageRoomForm));



// WEBPACK FOOTER //
// ./src/presentation/component/customer/message_rooms/main/customer_message_room_form.tsx